import React, { useState } from 'react'
import { useRef } from 'react';
import { useEffect } from 'react';

import { useContext } from 'react'

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Autocomplete, Box, Button, CircularProgress, FormControl, Grid2, InputLabel, Menu, MenuItem, OutlinedInput, Select, TextField, Typography } from '@mui/material';

import { AuthContext } from '../../utils/AuthContext';
import { addReferral, updateReferral } from '../../services/ReferralsService';

import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import CheckIcon from '@mui/icons-material/Check';
import moment from 'moment';


function ReferralFormDialog({ dialogOpen, setDialogOpen, callback, mode, referralParam }) {

    const { auth, setAuth } = useContext(AuthContext);


    const [clientName, setClientName] = useState('');
    const [birthday, setBirthday] = useState('');
    const [nationality, setNationality] = useState('');
    const [residence, setResidence] = useState('');
    const [email, setEmail] = useState('');
    const [contactNo, setContactNo] = useState('');
    const [remarks, setRemarks] = useState('');
    const [status, setStatus] = useState('');


    const [clientNameError, setClientNameError] = useState('');
    const [birthDayError, setBirthdayError] = useState('');
    const [nationalityError, setNationalityError] = useState('');
    const [residenceError, setResidenceError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [contactNoError, setContactNoError] = useState('');
    const [remarksError, setRemarksError] = useState('');
    const [statusError, setStatusError] = useState('');

    const [isLoading, setIsLoading] = useState(false);


    const startRef = useRef();



    useEffect(() => {

        if (dialogOpen) {
            setTimeout(() => {
                // startRef.current.getElementsByClassName('MuiInputBase-input')[0].focus();
            }, 100)
        }

        if (referralParam) {
            setClientName(referralParam.claw_back_name)
        }

    }, [dialogOpen, referralParam]);

    const handleClose = () => {
        setDialogOpen(false);
    };


    useEffect(() => {
        if (mode === "create") {
            return;
        }

        if (referralParam === null) {
            return;
        }

        setClientName(referralParam.client_name);
        setBirthday(referralParam.birthday);
        setNationality(referralParam.nationality);
        setResidence(referralParam.residence);
        setEmail(referralParam.email);
        setContactNo(referralParam.contact_no);
        setRemarks(referralParam.remarks);
        setStatus(referralParam.status);

    }, [referralParam, dialogOpen]);


    function handleAddReferral() {
        setIsLoading(true)
        const referral = new FormData();
        referral.append('client_name', clientName);
        referral.append('date_of_birth', birthday);
        referral.append('nationality', nationality);
        referral.append('residence', residence);
        referral.append('email_address', email);
        referral.append('contact_no', contactNo);
        referral.append('remarks', remarks);
        referral.append('status', status);

        addReferral({ token: auth.token, referral: referral }).then(res => {
            // clearForm()
            toast.success('New Referral Added', {
                autoClose: 1000,
                hideProgressBar: true,
                icon: ({ theme, type }) => <CheckIcon sx={{ color: '#3328BF' }} />,
                closeButton: false
            });
            setDialogOpen(false)
            setIsLoading(false)
            callback()
        })
    }

    function handleUpdateReferral() {
        setIsLoading(true)

        const referral = {
            'client_name': clientName,
            'date_of_birth': birthday,
            'nationality': nationality,
            'residence': residence,
            'email_address': email,
            'contact_no': contactNo,
            'remarks': remarks,
            'status': status,
        }

        // console.log(referral)

        updateReferral({ token: auth.token, referral: referral, referralId: referralParam.id }).then(res => {
            // clearForm()
            toast.success('Referral Updated', {
                autoClose: 1000,
                hideProgressBar: true,
                icon: ({ theme, type }) => <CheckIcon sx={{ color: '#3328BF' }} />,
                closeButton: false
            });
            setDialogOpen(false)
            setIsLoading(false)
            callback()
        });
    }

    function validate() {
        let isValid = true;

        if (clientName.trim() === '') {
            setClientNameError('Client Name is Required')
            isValid = false
        }

        return isValid;
    }

    function handleSubmit() {
        let isValid = validate();
        if (mode === 'create') {
            if (isValid) {
                handleAddReferral()
            }
        } else if (mode === 'update') {
            if (isValid) {
                handleUpdateReferral()
            }
        }
    }

    function getTitle() {
        if (mode === 'create') {
            return 'Add Referral'
        } else if (mode === 'update') {
            return 'Update Referral'
        } else if (mode === 'view') {
            return 'View Referral'
        }
    }




    return (
        <Dialog
            open={dialogOpen}
            onClose={handleClose}
            maxWidth
            sx={{ zIndex: 9998 }}
        >
            <DialogTitle sx={{ mt: 3 }}>
                { getTitle() }
            </DialogTitle>


            <DialogContent>
                <Grid2 container
                    component="form"
                    autoComplete="off"
                    method="POST"
                    onSubmit={(e) => {
                        e.preventDefault();
                        handleSubmit();
                    }}
                    sx={{
                        width: {
                            md: 400,
                            xs: '70vw'
                        }
                    }}
                >
                    <Grid2 size={{ xs: 12 }}>
                        <Box sx={{ mt: 1 }}>
                            <Typography sx={{ fontSize: 12, color: '#616161' }}>CLIENT NAME</Typography>
                            <OutlinedInput
                                sx={{ mt: 0.5 }}
                                size="small"
                                fullWidth
                                value={clientName}
                                onChange={ mode !== 'view' ? (e) => { setClientName(e.target.value) } : null}
                                error={clientNameError !== ''}
                            />
                            {clientNameError && <Typography sx={{ fontSize: 12, color: 'red' }}>{clientNameError}</Typography>}
                        </Box>

                        <Box sx={{ mt: 1 }}>
                            <Typography sx={{ fontSize: 12, color: '#616161' }}>BIRTHDAY</Typography>
                            <TextField
                                sx={{ mt: 0.5 }}
                                size="small"
                                fullWidth
                                type="date"
                                value={birthday}
                                onChange={mode !== 'view' ?  (e) => { setBirthday(e.target.value) } : null}
                                error={birthDayError !== ''}
                                inputProps={{
                                    readOnly: mode === 'view'
                                }}
                            />
                            {birthDayError && <Typography sx={{ fontSize: 12, color: 'red' }}>{birthDayError}</Typography>}
                        </Box>

                        <Box sx={{ mt: 1 }}>
                            <Typography sx={{ fontSize: 12, color: '#616161' }}>NATIONALITY</Typography>
                            <TextField
                                size='small'
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={nationality}
                                onChange={mode !== 'view' ? (e) => { setNationality(e.target.value) } : null}
                                error={nationalityError !== ''}
                                helperText={nationalityError}
                            />
                        </Box>

                        <Box sx={{ mt: 1 }}>
                            <Typography sx={{ fontSize: 12, color: '#616161' }}>RESIDENCE</Typography>
                            <TextField
                                size='small'
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={residence}
                                onChange={mode !== 'view' ? (e) => { setResidence(e.target.value) } : null}
                                error={residenceError !== ''}
                                helperText={residenceError}
                            />
                        </Box>

                        <Box sx={{ mt: 1 }}>
                            <Typography sx={{ fontSize: 12, color: '#616161' }}>EMAIL</Typography>
                            <TextField
                                size='small'
                                type="email"
                                fullWidth
                                variant="outlined"
                                value={email}
                                onChange={mode !== 'view' ? (e) => { setEmail(e.target.value) } : null}
                                error={emailError !== ''}
                                helperText={emailError}
                            />
                        </Box>

                        <Box sx={{ mt: 1 }}>
                            <Typography sx={{ fontSize: 12, color: '#616161' }}>Contact</Typography>
                            <TextField
                                size='small'
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={contactNo}
                                onChange={mode !== 'view' ? (e) => { setContactNo(e.target.value) } : null}
                                error={contactNoError !== ''}
                                helperText={contactNoError}
                            />
                        </Box>

                        <Box sx={{ mt: 1 }}>
                            <Typography sx={{ fontSize: 12, color: '#616161' }}>REMARKS</Typography>
                            <TextField
                                size='small'
                                type="text"
                                multiline
                                fullWidth
                                variant="outlined"
                                value={remarks}
                                onChange={mode !== 'view' ? (e) => { setRemarks(e.target.value) } : null}
                                error={remarksError !== ''}
                                helperText={remarksError}
                            />
                        </Box>
                        {
                            auth.user.user_type === 'Admin' && (
                                <Box sx={{ mt: 1, pb: 2 }}>
                                    <Typography sx={{ fontSize: 12, color: '#616161' }}>STATUS</Typography>
                                    <Select
                                        fullWidth
                                        size='small'
                                        onChange={(event) => {
                                            setStatus(event.target.value)
                                        }}
                                        value={status ?? ''}
                                        error={statusError !== ''}
                                        helperText={statusError}
                                        readOnly={mode === 'view' || (status !== 'New' && auth.user.user_type === 'Agent')}

                                    >
                                        <MenuItem value='New'>New</MenuItem>
                                        <MenuItem value='Pending'>Pending</MenuItem>
                                        <MenuItem value='Cancelled'>Cancelled</MenuItem>
                                        <MenuItem value='Closed'>Closed</MenuItem>
                                    </Select>
                                </Box>
                            )
                        }

                    </Grid2>
                </Grid2>
            </DialogContent>
            <DialogActions sx={{ mb: 3, mr: 3, mt: 2 }}>
                <Button onClick={handleClose}>{mode === 'view' ? 'Close' : 'Cancel'}</Button>

                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {
                        mode !== 'view' &&
                        <Button
                            variant='contained'
                            onClick={handleSubmit}
                            disabled={isLoading}
                        >
                            {mode == 'create' ? 'Submit' : 'Update'}
                        </Button>
                    }
                    {
                        isLoading &&
                        <CircularProgress size={24} sx={{ ml: 2 }} />
                    }
                </Box>

            </DialogActions>

        </Dialog>
    )
}

export default ReferralFormDialog